module.exports = __webpack_public_path__ + "img/reward_leaf_black_R.0760be29.png";